import React, { useState, useEffect } from 'react';
import { useParams, ScrollRestoration } from 'react-router-dom';
// Config
import { POSTER_SIZE, BACKDROP_SIZE, IMAGE_BASE_URL } from '../config';
import API from '../API'
// Components
import Header from './Header';
import Thumb from './Thumb';
import Knoppie from './Knoppie';
import InfoButton from './InfoButton'
import ClubHeader from './ClubHeader';
import SearchBar from './SearchBar';
import ButtonGrid from './ButtonGrid'
import List from './List'
import Spinner from './Spinner'

// Hook
import useAuth from '../hooks/useAuth';
import { useEmployeeListFetch } from '../hooks/useEmployeeList';
// Image
import NoImage from '../images/no-image.png';
import Grid from './Grid';


let renderCount = 0

const EmployeesList = () => {
  const auth = useAuth();
  const { playerid } = useParams()
  console.log(playerid)
  const [includeSwitch, setIncludeSwitch] = useState(false)

  const { state, loading, error, setSearchValue, setIncludeInactive, setLoading, setTrigger } = useEmployeeListFetch(playerid);
  const [departments, setDepartments] = useState()
  const [selectedDept, setSelectedDept] = useState('');
  console.log(departments)

  const handleScroll = () => {
    const element = document.getElementById(playerid ? playerid : "")
    console.log("handlescroll is getrigger")
    console.log(element)
    if (element) {
      element.scrollIntoView({

      })

    }

  }


  const handleClick = async (e) => {

    try {

      // eslint-disable-next-line no-restricted-globals
      const confirmation = confirm("Are you sure you want to Delete this employee? This action cannot be overturned!")
      if (confirmation) {
        setTrigger(true)

        console.log("Sukses, die employee gaan delete word hier")
        await API.deleteEmployee(e.target.id, auth.auth.accessToken)

      } else {
        return
      }
    } catch (error) {
      console.log(error)
    }

    console.log("gekliek op" + e.target.id)
    console.log(auth.auth.user.username)

  }

  useEffect(() => {
    if (state.employees.length > 0) {
      const uniqueDepts = [];
      state.employees.forEach(emp => {
        if (emp.dept && !uniqueDepts.includes(emp.dept)) {
          uniqueDepts.push(emp.dept);
        }
      });
      setDepartments(uniqueDepts);
    }
  }, [state.employees]);


  useEffect(() => {

    if (!loading) {
      handleScroll()
    }

  }, [state])

  const username = auth.auth.user.username

  const access = auth.auth.user.userRole
  // console.log(besluit.besluit[0].besluit)
  console.log(state)

  renderCount++
  return (
    <>

      <Header username={username} role={access} destination={'./'}></Header>

      {access === "administrator" || access === "manager" ?
        <Knoppie
          destination={`/addNewEmployee`}
          text={'Add new Employee'}
          clickable={true}
        />
        : ""}

      {/* <h1>RenderCount {renderCount/2}</h1> */}

      <div className='ListHead'>
        <SearchBar key={1} setSearchValue={setSearchValue}></SearchBar>
        <ButtonGrid>

          <select
            className="dept-select"
            value={selectedDept}
            onChange={(e) => setSelectedDept(e.target.value)}
          >
            <option value="">All Departments</option>
            {departments && departments.length > 0 && departments.map((dept, index) => (
              <option key={index} value={dept}>
                {dept}
              </option>
            ))}
          </select>

          <Knoppie
            text={'Show All'}
            clickable={true}
            dropdown={true}
            switchOn={includeSwitch === true}
            callback={() => {
              setIncludeInactive(true)
              setIncludeSwitch(true)
            }}
          />
          <Knoppie
            text={'Show Active Only'}
            clickable={true}
            dropdown={true}
            switchOn={includeSwitch === false}
            callback={() => {
              setIncludeInactive(false)
              setIncludeSwitch(false)
            }}
          />
        </ButtonGrid>
      </div>

      {error ? "error" : ""}
      <List header={`Employees ${state.employees.length}`}
        destination={''}>

        {/* <div className='SingleEmployee'>
        <Thumb
                 
           image={NoImage}      
          name={"Name"}
          area={"Surname"}
          phone={'Phone'}
        
          
        >
            <div></div>
            <div>Actions</div>
        </Thumb>

        </div> */}



        {loading ? <Spinner></Spinner> : ""}

        {state.employees
        .filter(emp => selectedDept === '' || emp.dept === selectedDept)
        .map(employee => (

          <>
            <div className='SingleEmployee'>
              <Thumb
                // onclick={setElementid(employee._id)}
                key={employee._id}
                clickable={true}
                image={employee.avatarUrl ? employee.avatarUrl : NoImage}
                name={employee.givname}
                area={employee.surname}
                phone={employee.phone}
                id={employee._id}
                players={""}
                points={employee.points ? employee.points : 0}
                employeeid={employee._id}
                from={`EmployeeList/${employee._id}`}

              >
                <InfoButton
                  text={employee.IDOnFile ? "ID" : "no ID"}
                  IDonFile={employee.IDOnFile}
                >

                </InfoButton>
                <Knoppie
                  clickable={true}
                  text={"Delete"}
                  destination={'../EmployeeList'}
                  employeeid={employee._id}
                  callback={handleClick}
                >

                </Knoppie>



              </Thumb>


            </div>
          </>

        ))}


      </List>

    </>
  );
};

export default EmployeesList;

